import React from 'react'
import Link from 'gatsby-link'
import NavLink from './navlink'
import NavLinkExt from './navlinkext'

const Menu = () => (
  <div
    style={{
      background: '#171717',
      color: '#cfcfcf',
      fontSize: '20px',
    }}
  >

  <nav>
    <ul style={{ margin: '0' }}>
      <NavLink url="/releases" text="releases" />
      <NavLink url="/artists" text="artists" />
      <NavLink url="/booking" text="booking" />
    </ul>
  </nav>

  </div>
)

export default Menu



// WEBPACK FOOTER //
// ./src/components/menu.js